import {
    convertToMultiselectLabels,
    Form,
    FormControlChangeType,
    IFormConfig,
    IModelDictionaryDatum,
    serviceTypesSelector,
    sortMultiselectLabels,
} from 'jobhunter-common-web';
import React, {Component} from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {BehaviorSubject, Subscription} from 'rxjs';
import {debounceTime, filter, tap} from 'rxjs/operators';
import {marketplaceFiltersFormConfig} from './marketplaceFiltersFormConfig';
import {connect} from 'react-redux';
import {RootState} from '../../../store/reducers';

interface IConnectedServiceFiltersProps {
    readonly serviceTypes: typeof IModelDictionaryDatum[] | null;
}

interface IExternalServiceFiltersProps {
    readonly changeFilters: (value: {[key: string]: any}) => void;
}

interface IServiceFiltersProps extends IConnectedServiceFiltersProps, IExternalServiceFiltersProps, WithTranslation {}

interface IServiceFiltersState {
    value: any;
    formConfig: typeof IFormConfig | null;
    isLoading: boolean;
}

class ServiceFilters extends Component<IServiceFiltersProps, IServiceFiltersState> {
    readonly onValueStateChange$: BehaviorSubject<any> = new BehaviorSubject(null);
    private subscriptions: Subscription[] = [];

    constructor(props: IServiceFiltersProps) {
        super(props);

        this.state = {
            value: null,
            formConfig: null,
            isLoading: false,
        };
    }

    componentDidMount(): void {
        this.setFormConfig();

        this.subscriptions.push(
            this.onValueStateChange$
                .pipe(
                    filter((data: any) => data && data.changeType === FormControlChangeType.User),
                    debounceTime(250),
                    tap((data: any) => this.onFormValueChange(data.value))
                )
                .subscribe()
        );
    }

    componentDidUpdate(prevProps: IServiceFiltersProps) {
        if (this.props.serviceTypes !== prevProps.serviceTypes) {
            this.setFormConfig();
        }
    }

    componentWillUnmount() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    render() {
        return (
            <div className="mb-4">
                {this.state.formConfig && (
                    <Form
                        config={this.state.formConfig}
                        onValueStateChange={this.onValueStateChange}
                        value={this.state.value}
                        controlName={'marketplaceFiltersForm'}
                    />
                )}
            </div>
        );
    }

    private onValueStateChange = (controlName: string, value: any, changeType: typeof FormControlChangeType) => {
        this.onValueStateChange$.next({controlName: controlName, value: value, changeType: changeType});
    };

    private onFormValueChange = (value: any) => {
        this.props.changeFilters(value);
    };

    private setFormConfig = () => {
        const {t} = this.props,
            serviceTypes = this.props.serviceTypes ? sortMultiselectLabels(convertToMultiselectLabels(this.props.serviceTypes, t)) : [];

        this.setState({formConfig: marketplaceFiltersFormConfig(serviceTypes)});
    };
}

export default connect(
    (state: RootState) => ({
        serviceTypes: serviceTypesSelector(state),
    }),
    {}
)(withTranslation()(ServiceFilters));
